$(document).ready(function(){
    getRecentView()
})


// 篩選框
$('.js-click-view').click(function(){
    // 有hover class代表沒選
    var check = $(this).hasClass('js-checkbox-hover')

    if(check){
        $(this).removeClass('js-checkbox-hover')
        $(this).find('input:checkbox').attr("checked", "checked");
        $(this).find('label , label,span').addClass('red-text');
    }else{
        $(this).addClass('js-checkbox-hover')
        $(this).find('input:checkbox').removeAttr("checked");
        $(this).find('label, label,span').removeClass('red-text');
    }
})

$('.js-check-view.hover-sub-font-primary').click(function(){
    $(this).closest('.js-check-wrap').find('.js-check-view').removeClass('red-text').addClass('text-dark')
    $(this).find('h2 ,span').addClass('red-text');
})

function getRecentView() {
    if($('.js-recent-view').length){
        $.ajax({
            url: '/customer/recentView-new',
            type:"POST",
            success: function(data){
                data = JSON.parse(data);
                if(data.success){
                    $('.js-recent-view').html(data.html);

                    new Swiper('.swiper-carousel', {
                        lazy: true,
                        observer: true,
                        observeParents: true,
                        preloadImages: false,
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                        navigation: {
                          nextEl: '.swiper-button-next',
                          prevEl: '.swiper-button-prev',
                        },
                        breakpoints: {
                            769: {
                                slidesPerView: 6,
                                slidesPerGroup: 6,
                            }
                        }
                    });
                    
                }else{
                }
            },
            error:function(xhr, ajaxOptions, thrownError){
            }
        });
    }    
}

$('.js-select-motor-manufacturer').on('select2:select', function (e) {
    var data = $(this).find('option:selected').val();
    AjaxGetManufacturer(data,renderDisplacementSelect)
});

$('.js-select-motor-displacement').on('select2:select', function (e) {
    var displacement = $(this).find('option:selected').val();
    var manufacturer = $(".js-select-motor-manufacturer option:selected").val();
    AjaxGetModel(manufacturer , displacement ,renderModelSelect)
});

$('.js-select-motor-model').on('select2:select', function (e) {
    swichAddMyBikeBtn()
});


// 品牌搜索選中即跳轉
$('.js-select-brand').on('select2:select',function(){
    window.location = $(this).find('option:selected').attr('data-href')
})

// 關鍵字搜索
$(document.body).on('submit', '.input-search-keyword-form' ,function(){
    target_url = $(this).attr('action');
    if(target_url){
        target_url = decodeURIComponent(target_url);

        search_value = $(this).find('input[type=text]').val();

        if(search_value){
            window.location.href = addParameter(target_url,'q',search_value);
            return false;
        }
    }
});

// 搜索 的提示窗
$(document.body).on('focus', '#input-search-keyword' ,function(){
    var current_suggest_connection = null;
    var _this = $(this)
    _this.autocomplete({
        minLength: 1,
        source: solr_source_search,
        focus: function( event, ui ) {
            _this.val( ui.item.label );
            return false;
        },
        select: function( event, ui ) {
            ga('send', 'event', 'suggest', 'select', 'parts');
            location.href = ui.item.href;
            return false;
        },
        change: function(event, ui) {
        }
    })
        .autocomplete( "instance" )._renderItem = function( ul, item ) {

        var bag = $( "<li>" );
        if( item.value == 'cut' ){
            return bag.addClass('cut').append('<hr>').appendTo( ul );
        }

        return bag
            .append( '<a  href="'+ item.href +'">' + item.icon + '<span class="label size-10rem font-normal font-color-normal">' + item.label + "</span></a>" )
            .appendTo( ul );
    };
    function solr_source_search(request, response){

        var params = {q: request.term ,parts:true,url:window.location.pathname};

        current_suggest_connection = $.ajax({
            url: "{{ route('api-suggest')}}",
            method:'GET',
            data : params,
            dataType: "json",
            beforeSend: function( xhr ) {
                if(current_suggest_connection){
                    current_suggest_connection.abort();
                }
            },
            success: function(data) {
                response(data);
            }
        });
    }
});

// 排序選擇即跳轉
$(document).on('change', '.js-select-option-redirect', function(){
    window.location = $(this).val();
});

$(document).on('click','.js-moto-modal-render',function(){
    var data = $(this).find('.js-modal-data').html();
    var title = $(this).closest('.js-product-item').find('.js-product-name').text();
    $('#motoModal .modal-body').html(data);
    $('#motoModal .modal-title').html(title + '-適用車型');
})

function AjaxGetManufacturer(data,todo){
    // 1.驗證有值
    if(!data){
        return false
    }
    // 2.發送請求
    var url = "/api/motor/displacements?manufacturer=" + data
    $.ajax({
        'url' : url,
        'type' : 'get',
        success: function(data){
            // 3.獲取數據執行動作
            todo(data);
        }
    })
}

function swichAddMyBikeBtn(){
    if(checkMyBikeDataComplete()){
        $('.js-search-myBike').removeAttr('disabled')
    }else{
        $('.js-search-myBike').attr('disabled','true')
    }
}

function AjaxGetModel(manufacturer , displacement , todo){
    // 1.驗證有值
    if(!manufacturer){
        return false
    }
    if(!displacement){
        return false
    }

    // 2.發送請求
    var url = "/api/motor/model?manufacturer=" + manufacturer + "&displacement=" + displacement

    $.ajax({
        'url' : url,
        'type' : 'get',
        success: function(data){
            todo(data)
        }
    })
}

function renderDisplacementSelect(data){
    // 清空舊資料
    cleanSelect2('.js-select-motor-displacement')
    cleanSelect2('.js-select-motor-model')

    // 放入title
    addDisplacementSelectTitle()
    addModelSelectTitle()

    // 放入內容
    for(var key in data){
        var cc = {
            id: data[key],
            text: data[key]
        };

        var DisplacementSelect = new Option(cc.text, cc.id, false, false);
        $('.js-select-motor-displacement').append(DisplacementSelect).trigger('change');
    }
    // 車型套用禁用狀態
    $('.js-select-motor-model').attr('disabled',true);
    // 解除該選單的禁用狀態
    $('.js-select-motor-displacement').removeAttr('disabled');
    // 確認按鈕狀態
    swichAddMyBikeBtn()
}

function renderModelSelect(data){
    // 清空舊資料
    cleanSelect2('.js-select-motor-model')
    // 放入title
    addModelSelectTitle()
    // 放入內容
    for(var key in data){
        var cc = {
            id: data[key].key,
            text: data[key].name
        };
        var DisplacementSelect = new Option(cc.text, cc.id, false, false);
        $('.js-select-motor-model').append(DisplacementSelect).trigger('change');
    }
    // 解除該選單的禁用狀態
    $('.js-select-motor-model').removeAttr('disabled');
    // 確認按鈕狀態
    swichAddMyBikeBtn()
}

function checkMyBikeDataComplete(){
    var manufacturer = $('.js-select-motor-manufacturer option:selected').first().val();
    var displacement =$('.js-select-motor-displacement option:selected').first().val();
    var model = $('.js-select-motor-model option:selected').first().val();

    if(manufacturer == '-1' || !manufacturer){
        return false
    }

    if(displacement == '-1' || !displacement){
        return false
    }

    if(model == '-1' || !model){
        return false
    }

    return true
}

function cleanSelect2(selectName){
    $(selectName).empty();
    $(selectName).val(null).trigger('change');
}

function addDisplacementSelectTitle(){
    var title = {
        id: -1,
        text: 'cc數'
    };
    var DisplacementTitle = new Option(title.text, title.id, false, false);
    $('.js-select-motor-displacement').append(DisplacementTitle).trigger('change')

    // 將title 設置為禁用
    $(".js-select-motor-displacement option[value='-1']").attr('disabled',true);
}

function addModelSelectTitle(){
    var title = {
        id: -1,
        text: '型號'
    };
    var DisplacementTitle = new Option(title.text, title.id, false, false);
    $('.js-select-motor-model').append(DisplacementTitle).trigger('change')

    // 將title 設置為禁用
    $(".js-select-motor-model option[value='-1']").attr('disabled',true);
}
